const removeElements = new Set();
const longestRows = new Map();

const MAX_DISTANCE = 64;

class RegionInfo {
    constructor(elementIds, glraycastBuffer) {
        this._elementIds = elementIds;
        this._glraycastBuffer = glraycastBuffer;
        this._onBufferUpdateThis = this._onBufferUpdate.bind(this);

        this._updateListeners = new Set();

        this._running = false;
        this._data = new Map();
    }

    get data() {
        return this._data;
    }

    listenUpdate(callback) {
        this._updateListeners.add(callback);
    }

    unlistenUpdate(callback) {
        this._updateListeners.delete(callback);
    }

    start() {
        if (this._running) return;
        this._running = true;

        this._glraycastBuffer.listenUpdate(this._onBufferUpdateThis);
    }

    stop() {
        if (!this._running) return;
        this._running = false;

        this._glraycastBuffer.unlistenUpdate(this._onBufferUpdateThis);
    }

    _onBufferUpdate() {
        const bufData = this._glraycastBuffer.data;

        if (bufData) {
            for (const element in this._data.keys()) {
                removeElements.add(element);
            }

            const { width, height, pixels } = bufData;

            let pos = 0;
            for (let y = 0; y < height; y++) {
                let currentRowSlotId = null;
                let currentRowX0 = null;

                for (let x = 0; x < width; x++, pos++) {
                    const off = pos << 2;
                    const r = pixels[off + 0], g = pixels[off + 1];
                    const slotId = r * 255 + g;

                    if (slotId !== currentRowSlotId) {
                        if (currentRowSlotId !== null) {
                            const rowLength = x-currentRowX0;

                            if (longestRows.has(currentRowSlotId)) {
                                const rowData = longestRows.get(currentRowSlotId);

                                if (rowLength > rowData.length) {
                                    rowData.x0 = currentRowX0;
                                    rowData.y = y;
                                    rowData.length = rowLength;
                                }
                            } else {
                                longestRows.set(currentRowSlotId, {
                                    x0: currentRowX0,
                                    y: y,
                                    length: rowLength,
                                });
                            }
                        }

                        currentRowSlotId = slotId;
                        currentRowX0 = x;
                    }
                }
            }

            for (const [slotId, { x0, y, length }] of longestRows) {
                const slot = this._elementIds.getIdSlot(slotId);
                const element = this._elementIds.getSlotElement(slot);

                if (element !== undefined) {
                    removeElements.delete(element);

                    let regionData = this._data.get(element);

                    if (!regionData) {
                        regionData = {};
                        this._data.set(element, regionData);
                    }

                    regionData.x0 = x0;
                    regionData.length = length;
                    regionData.y = height-y-1;

                    const xMid = Math.floor(x0+length*0.5)

                    const off = (y*width+xMid)*4;
                    const b = pixels[off + 2], a = pixels[off + 3];
                    regionData.depth = ((b << 8) | a) * MAX_DISTANCE * 0.000015318627450980392; // 1/255/256
                }
            }

            for (const element of removeElements) {
                this._data.delete(element);
            }

            removeElements.clear();
            longestRows.clear();
        } else {
            this._data.clear();
        }

        for (const callback of this._updateListeners) {
            callback(this);
        }
    }
}

export default RegionInfo;
